import { ColorOptions } from "@/src/types";
import { MainInner, StyledMainSection } from "@/styles/global";
import { Body, H3, H3Css, SmallHeading2 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
type BackgroundProps = {
  $backgroundColor?: ColorOptions;
  $color?: ColorOptions;
};

const Section = styled(StyledMainSection)``;

const Inner = styled(MainInner)``;

const ScrollContainer = styled.div`
  overflow: scroll;
  padding: 0px 16px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 88px;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 8px;
  }

  @media screen and (min-width: 1512px) {
    padding: 0 calc(50vw - 756px + 88px);
  }
`;

const Container = styled.div`
  display: flex;
  gap: 24px;
  width: max-content;
`;

const Image = styled(GatsbyImage)`
  position: relative;
  width: 100%;
  height: 228px;
  max-height: 228px;
  min-height: 228px;
  transition: all 0.2s ease-in-out;
  z-index: 1;
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  img {
    object-fit: cover;
    object-position: center;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 32px;
  justify-content: space-between;

  p {
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

const CardTextInner = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardWrapper = styled.div<BackgroundProps>`
  border-radius: 14px;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  overflow: hidden;
  transform: translateZ(0);
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor || "black"]};
`;

const CardTitle = styled(H3)<BackgroundProps>`
  color: ${({ theme, $color }) => theme.colors[$color || "black"]};
`;

const CardSubTitle = styled(Body)<BackgroundProps>`
  font-size: 16px;
  color: ${({ theme, $color }) => theme.colors[$color || "black"]};
`;

const CardSmallHeading = styled(SmallHeading2)<BackgroundProps>`
  color: ${({ theme, $color }) => theme.colors[$color || "black"]};
`;

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 308px;
  height: 385px;
  text-decoration: none;
  scroll-snap-align: start;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    cursor: pointer;
    height: 395px;

    ${Image} {
      img {
        transition: all 0.2s ease-in-out;
      }
    }

    &:hover {
      ${Image} {
        img {
          transform: scale(1.04);
        }
      }
    }
  }
`;

const Wrapper = styled.div<BackgroundProps>`
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor || "black"]};
  padding: 40px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 88px 0;
  }
`;

const Button = styled.div`
  width: 100%;
  border: none;
  padding: 4px 0;
  text-decoration: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    p {
      transition: all 0.2s ease-in-out;
    }

    &:hover {
      p {
        opacity: 0.6;
      }
    }
  }
`;

const TitleArrowWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

const Title = styled.h2<{ $color?: string }>`
  ${H3Css}
  color: ${({ theme, $color }) => theme.colors[$color || "black"]};
  text-transform: uppercase;
`;

const ArrowsWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 32px);
  height: calc(100vh - 32px);
  display: flex;
  z-index: 1000;
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 90vw;
    height: 90vh;
  }
`;

const ModalInner = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  padding: 56px 16px 24px 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 80px;
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  right: 24px;
  width: 24px;
  z-index: 1000;
  cursor: pointer;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 24px;
    height: 24px;
  }
`;

const S = {
  Section,
  Inner,
  ScrollContainer,
  Container,
  Image,
  TextWrapper,
  CardWrapper,
  CardTitle,
  CardSubTitle,
  CardTextInner,
  CardSmallHeading,
  Card,
  Wrapper,
  Button,
  TitleArrowWrapper,
  Title,
  ArrowsWrapper,
  Backdrop,
  Modal,
  ModalInner,
  CloseButton,
};

export default S;
